




import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'badge-overnightavailable-component',
})
export default class OvernightAvailableComponent extends Vue {
}
